import { Button } from '@wheely/ui-kit';
import { FormattedMessage } from 'react-intl';

import { IDriver, TransferRequestStatuses } from '@/modules/driver/model/driver';

import { CurrentVehicle } from './CurrentVehicle';
import { OrdersInfo } from './OrdersInfo';
import { PersonalInfo } from './PersonalInfo';
import { Statistics } from './Statistics';
import s from './TabOverview.module.css';

interface IProps {
  driver: IDriver;
  onClickBlock: () => void;
  onClickDismiss: () => void;
  isPending: boolean;
}

const Overview = ({ driver, onClickBlock, onClickDismiss, isPending }: IProps) => {
  const isBlockActionAllowed = driver.blockInfo === undefined;
  const isDismissActionAllowed = driver.transferRequest?.status === TransferRequestStatuses.pending;

  return (
    <>
      <CurrentVehicle driver={driver} />
      <PersonalInfo driver={driver} />
      <OrdersInfo driver={driver} />
      <Statistics driver={driver} />
      {(isBlockActionAllowed || isDismissActionAllowed) && (
        <div className={s.actions}>
          {isBlockActionAllowed && (
            <Button
              minimal={true}
              intent="danger"
              className={s.deleteButton}
              onClick={onClickBlock}
              data-test-id="block-driver"
              disabled={isPending}
            >
              <FormattedMessage
                defaultMessage="Block chauffeur"
                id="v+X3Zo"
                description="Driver profile: action button"
              />
            </Button>
          )}
          {isDismissActionAllowed && (
            <Button
              minimal={true}
              onClick={onClickDismiss}
              data-test-id="transfer-driver"
              disabled={isPending}
            >
              <FormattedMessage
                defaultMessage="Dismiss"
                id="mzkAJN"
                description="Driver profile: Dismiss action button"
              />
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export type { IProps };
export { Overview };
